import React, { useEffect, useState } from 'react';
import { SHELL_WHITE } from '../../theme/colors';

// Fetches the shared iris mark and re-tints its stroke, same technique as
// StateIcon in src/components/trends/WeekTimelines.js — the source SVG is
// stroke="white", so a plain <img> can't be recolored for the footer's
// navy-on-cream context without this.
const Logo = ({ size = 22, color = SHELL_WHITE, textColor, textSize = 22 }) => {
  const [svg, setSvg] = useState(null);

  useEffect(() => {
    fetch('/state-assets/icons/main-icon.svg')
      .then((r) => {
        if (!r.ok) throw new Error(`main-icon.svg fetch failed: ${r.status}`);
        return r.text();
      })
      .then((text) => {
        const tinted = text
          // The source file has no stroke-width at all (SVG default is 1),
          // which at icon size renders as a near-invisible hairline
          // regardless of color — that's why the mark looked "faint", not
          // the tint. The approved Paper spec uses stroke-width="8" (of a
          // 199-unit viewBox).
          .replace(/stroke="white"/g, `stroke="${color}" stroke-width="8"`)
          // The source file hardcodes width="199" height="199" (its viewBox
          // size) — without stripping those, the injected <svg> ignores the
          // wrapper div's size entirely and renders at ~199px regardless of
          // `size`, which is why the mark and the "vesna" text looked like
          // they were on two different planes instead of aligned in one row.
          .replace(/<svg([^>]*)width="[^"]*"/, '<svg$1width="100%"')
          .replace(/height="[^"]*"/, 'height="100%"');
        setSvg(tinted);
      })
      .catch(() => {});
  }, [color]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
      {svg && (
        <div
          dangerouslySetInnerHTML={{ __html: svg }}
          aria-hidden="true"
          style={{ width: size, height: size, flexShrink: 0, display: 'flex' }}
        />
      )}
      <span style={{ fontFamily: 'Instrument Serif', fontSize: textSize, fontWeight: 400, color: textColor ?? color }}>
        vesna
      </span>
    </div>
  );
};

export default Logo;
